/** Small threshold value used for floating-point distance comparisons in path calculations. */
const DISTANCE_EPSILON = 0.00001;

export default DISTANCE_EPSILON;
